import React, { useState } from 'react'
import LoanUtilityMain from './newloanutility'
import ProcessingFee from './ProcessingFee'
import ProductMain from './ProductMain'
import Product from './ProductMainnew'
import ReferalMain from './ReferalSection/Main'
import OverdueUtility from './Overdue/OverdueUtility'
import UploadUtility from './UploadUtility'
import { Company_DATA, CheckFunction, ABHICASH_LIKE, CHECK_COMPANY_TENANT, ABHICASH_ONLY, CASHBRIDGE_LIKE } from '../../../../../layouts/MainTenantconfig'
export default function configMain({ admin }) {
    const tenant = CheckFunction();
    const [tabs, setabs] = useState('loan')
    const handletabs = (type) => {
        setabs(type)
    }
    return (
        <>
            <div className="LoanUtility">

                <div className="tabs">
                    <div className={`tab ${tabs === 'loan' ? 'active' : ''}`} onClick={() => handletabs('loan')}>
                        <h5>Loan Utility</h5>
                    </div>
                    <div className={`tab ${tabs === 'processing' ? 'active' : ''}`} onClick={() => handletabs('processing')}>
                        <h5>Processing Fee</h5>
                    </div>
                    <div className={`tab ${tabs === 'product' ? 'active' : ''}`} onClick={() => handletabs('product')}>
                        <h5>Product</h5>
                    </div>
                    {
                        CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                            <div className={`tab ${tabs === 'Referal' ? 'active' : ''}`} onClick={() => handletabs('Referal')}>
                                <h5>Referral</h5>
                            </div>
                            : ''}
                    <div className={`tab ${tabs === 'overdue' ? 'active' : ''}`} onClick={() => handletabs('overdue')}>
                        <h5>Overdue</h5>
                    </div>
                    {
                         CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ?
                         <div className={`tab ${tabs === 'uploadUtility' ? 'active' : ''}`} onClick={() => handletabs('uploadUtility')}>
                        <h5>Upload Utility</h5>
                    </div>
                    :""}
                </div>

                {
                    tabs === 'loan' ?
                        <LoanUtilityMain />
                        : ''}
                {
                    tabs === 'processing' ?
                        <ProcessingFee />
                        : ''}
                {
                    tabs === 'product' ?
                        // <ProductMain />
                        <Product />
                        : ''}
                {
                    tabs === 'Referal' ?
                        <ReferalMain admin={admin} />
                        : ''}
                {
                    tabs === 'overdue' ?
                        <OverdueUtility admin={admin} />
                        : ''}
                {
                    tabs === 'uploadUtility' ?
                        <UploadUtility admin={admin} />
                        : ''}
            </div>
        </>
    )
}
